import { sanitizeSegment } from "../../storage/fsa.ts";

/**
 * Output tree for Contacts (ARCHITECTURE.md §7):
 *
 *   contacts/contacts.vcf
 *   contacts/contacts.csv
 *   contacts/_raw/<id>.json   intermediate — not part of the documented tree,
 *                             same role as Teams' messages/ and Mail's .eml
 *                             files: one resumable item per contact, read
 *                             back to regenerate the two real output files.
 */

export const CONTACTS_RAW_DIR = "contacts/_raw";
export const CONTACTS_VCF_PATH = "contacts/contacts.vcf";
export const CONTACTS_CSV_PATH = "contacts/contacts.csv";

export function contactRawPath(contactId: string): string {
    return `${CONTACTS_RAW_DIR}/${sanitizeSegment(contactId)}.json`;
}
